import { useRouteController } from '@siloreal:shared:hooks/controller/route/use-route-controller';
import { useEffect, useMemo } from 'react';

export type SilosProTab = 'vrr' | 'no-vrr' | 'closed';
export type SilobagTab = 'active' | 'closed' | 'archived';

export type SilobagListLogicState =
  | { view: 'silospro'; tab: SilosProTab }
  | { view: 'silobag'; tab: SilobagTab };

const INITIAL_STATE: SilobagListLogicState = { view: 'silospro', tab: 'vrr' };

export function useSilobagListLogicState() {
  const { fragment, navigate } = useRouteController();
  const state = useMemo<SilobagListLogicState>(() => {
    const [view, ...tabParts] = fragment.current.split('-');
    const tab = tabParts.join('-');

    if (view === 'silospro' && (tab === 'vrr' || tab === 'no-vrr' || tab === 'closed')) {
      return { view, tab };
    }

    if (view === 'silobag' && (tab === 'active' || tab === 'closed' || tab === 'archived')) {
      return { view, tab };
    }

    return INITIAL_STATE;
  }, [fragment.current]);

  useEffect(() => {
    if (!fragment.current) {
      fragment.change('silospro-vrr');
    }
  }, [fragment]);

  const change = useMemo(() => {
    const changeTab = (nextFragment: string) => {
      if (nextFragment === fragment.current) return;
      navigate({ query: {}, fragment: nextFragment });
    };

    return {
      view: {
        silospro: () => changeTab('silospro-vrr'),
        silobag: () => changeTab('silobag-active'),
      },
      tab: {
        silospro: (tab: SilosProTab) => changeTab(`silospro-${tab}`),
        silobag: (tab: SilobagTab) => changeTab(`silobag-${tab}`),
      },
    };
  }, [fragment.current, navigate]);

  return { state, change };
}
